import React, {DetailedHTMLProps, forwardRef, HTMLAttributes, Ref} from "react";
import {graphql, useStaticQuery} from "gatsby";
import clsx from "clsx";

import * as classNames from "@css/component/SiteReviews.module.scss";
import Stars from "@js/component/Stars";
import GoogleLogo from "@img/Google_2015_logo.svg";


/**
 * @type SiteReviewsProps
 */
export type SiteReviewsProps = Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "children">;

/**
 * @type SiteReviewData
 */
export type SiteReviewData = {
    siteReview: {
        totalCount: number;
        totalScore: number;
        totalScorePercentage: number;
    };
};

const SiteReviews = (props: SiteReviewsProps, ref: Ref<HTMLDivElement>) => {
    const {className, ...restProps} = props;

    const data: SiteReviewData = useStaticQuery(graphql`
        query {
            siteReview {
                totalCount
                totalScore
                totalScorePercentage
            }
        }
    `);

    const rating = data.siteReview.totalScore.toFixed(1); // Format rating (e.g., 4.9)
    const starPercentage = data.siteReview.totalScorePercentage;

    return (
        <div {...restProps} className={clsx(classNames.siteReviews, className)}
             ref={ref}>
            <a className={classNames.reviewContainer}
               target="_blank"
               rel="noopener noreferrer"
               href="//www.google.com/maps/place/Woninglabel.nl/@52.1273704,5.0458288,17z/data=!3m1!4b1!4m5!3m4!1s0x47c9cde1dd6f973b:0x75cb01829791b934!8m2!3d52.1273704!4d5.0458288"
            >
                <div className={classNames.googleLogo}>
                    <GoogleLogo width="100" height="20" />
                </div>
                <span className={classNames.reviewText}>Reviews</span>
                <Stars
                    backgroundColor="#ddd"
                    foregroundColor="#FABD03"
                    foregroundPercentage={starPercentage}
                />
                <span className={classNames.rating}>{rating}/5</span>
            </a>
        </div>
    );
};

export default forwardRef(SiteReviews);

